import "core-js/modules/es.string.replace-all.js";
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createSlots as _createSlots, vShow as _vShow } from "vue";
const _hoisted_1 = {
  class: "file-list-wrap"
};
const _hoisted_2 = {
  class: "div-086"
};
const _hoisted_3 = {
  class: "tips"
};
const _hoisted_4 = {
  class: "lf"
};
const _hoisted_5 = {
  class: "tip-title"
};
const _hoisted_6 = {
  class: "c1"
};
const _hoisted_7 = {
  class: "c2"
};
const _hoisted_8 = {
  class: "src-detail"
};
const _hoisted_9 = {
  class: "src-title"
};
const _hoisted_10 = {
  class: "src-title-left",
  style: {
    "display": "flex"
  }
};
const _hoisted_11 = {
  class: "position-name"
};
const _hoisted_12 = {
  class: "audit-div"
};
const _hoisted_13 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_date_picker = _resolveComponent("el-date-picker");
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
  const _component_el_dropdown = _resolveComponent("el-dropdown");
  const _component_el_tooltip = _resolveComponent("el-tooltip");
  const _component_icon = _resolveComponent("icon");
  const _component_el_popover = _resolveComponent("el-popover");
  const _component_el_table_column = _resolveComponent("el-table-column");
  const _component_audit_state = _resolveComponent("audit-state");
  const _component_el_button = _resolveComponent("el-button");
  const _component_sensitive_words_dialog = _resolveComponent("sensitive-words-dialog");
  const _component_el_table = _resolveComponent("el-table");
  const _component_el_card = _resolveComponent("el-card");
  const _component_el_scrollbar = _resolveComponent("el-scrollbar");
  const _component_detail_aside = _resolveComponent("detail-aside");
  const _component_src_audit = _resolveComponent("src-audit");
  const _component_el_dialog = _resolveComponent("el-dialog");
  const _component_router_view = _resolveComponent("router-view");
  const _directive_has = _resolveDirective("has");
  const _directive_loading = _resolveDirective("loading");
  return _openBlock(), _createElementBlock(_Fragment, null, [_withDirectives(_createElementVNode("div", _hoisted_1, [_createElementVNode("div", null, [_createVNode(_component_el_row, {
    class: "prop-col"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 8
    }, {
      default: _withCtx(() => [_createVNode(_component_el_row, null, {
        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createTextVNode("素材名称", -1)]))]),
        _: 1
      }), _createVNode(_component_el_row, {
        class: "prop-val-row"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: _ctx.demand.name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.demand.name = $event),
          size: "small",
          readonly: ""
        }, null, 8, ["modelValue"])]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 16
    }, {
      default: _withCtx(() => [_createVNode(_component_el_row, null, {
        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode("需求人", -1)]))]),
        _: 1
      }), _createVNode(_component_el_row, {
        class: "prop-val-row"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.demand.createrName) + "    " + _toDisplayString(_ctx.demand.createrDepName), 1)]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "prop-col"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 8
    }, {
      default: _withCtx(() => [_createVNode(_component_el_row, null, {
        default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode("素材有效期", -1)]))]),
        _: 1
      }), _createVNode(_component_el_row, {
        class: "prop-val-row"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_date_picker, {
          modelValue: _ctx.demand.validDate,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.demand.validDate = $event),
          type: "daterange",
          "range-separator": "~",
          "start-placeholder": "开始日期",
          "end-placeholder": "结束日期",
          readonly: ""
        }, null, 8, ["modelValue"])]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 8
    }, {
      default: _withCtx(() => [_createVNode(_component_el_row, null, {
        default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createTextVNode("联系方式", -1)]))]),
        _: 1
      }), _createVNode(_component_el_row, {
        class: "prop-val-row"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.demand.phone), 1)]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  })]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_cache[10] || (_cache[10] = _createElementVNode("i", {
    class: "el-icon-info"
  }, null, -1)), _createElementVNode("div", _hoisted_5, [_cache[8] || (_cache[8] = _createTextVNode(" 已选择 ", -1)), _createElementVNode("b", _hoisted_6, _toDisplayString(_ctx.multiSrss.length), 1), _cache[9] || (_cache[9] = _createTextVNode(" 项 | 总计素材数量：", -1)), _createElementVNode("b", _hoisted_7, _toDisplayString(_ctx.srcsLength), 1)])]), _createVNode(_component_el_dropdown, {
    trigger: "click"
  }, _createSlots({
    default: _withCtx(() => [_cache[12] || (_cache[12] = _createElementVNode("span", {
      class: "el-dropdown-link rt"
    }, [_createTextVNode(" 批量操作"), _createElementVNode("i", {
      class: "el-icon-arrow-down el-icon--right rt-icon"
    })], -1))]),
    _: 2
  }, [_ctx.demand.state == 2 ? {
    name: "dropdown",
    fn: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.srcAuditRoles, role => {
        return _openBlock(), _createElementBlock(_Fragment, {
          key: role.roleId
        }, ['yewu' === role.roleId ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_ctx.demand.createrId === _ctx.userInfo.userId ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
          key: 0,
          onClick: $event => $setup.showAuditDialog(role)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(role.roleName) + "审核 ", 1)]),
          _: 2
        }, 1032, ["onClick"])) : _createCommentVNode("", true)], 64)) : _withDirectives((_openBlock(), _createBlock(_component_el_dropdown_item, {
          key: 1,
          onClick: $event => $setup.showAuditDialog(role)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(role.roleName) + "审核 ", 1)]),
          _: 2
        }, 1032, ["onClick"])), [[_directive_has, role.auth]])], 64);
      }), 128)), _ctx.demand.createrId === _ctx.userInfo.userId ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
        key: 0,
        onClick: $setup.handlePressAudit
      }, {
        default: _withCtx(() => [...(_cache[11] || (_cache[11] = [_createTextVNode("催审核 ", -1)]))]),
        _: 1
      }, 8, ["onClick"])) : _createCommentVNode("", true)]),
      _: 1
    })]),
    key: "0"
  } : undefined]), 1024)]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_el_scrollbar, {
    height: "100%"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.positions, (p, index) => {
      return _openBlock(), _createBlock(_component_el_card, {
        class: "position-card",
        key: index
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createVNode(_component_el_tooltip, {
          effect: "light",
          content: p.positionAllname.replaceAll('^', ' > '),
          offset: "5",
          placement: "top-start"
        }, {
          default: _withCtx(() => [_createElementVNode("span", _hoisted_11, _toDisplayString(p.positionAllname.replaceAll('^', ' > ')), 1)]),
          _: 2
        }, 1032, ["content"]), _createVNode(_component_el_popover, {
          width: "200px",
          effect: "light",
          title: "素材要求",
          placement: "right",
          trigger: "hover",
          offset: "5"
        }, {
          reference: _withCtx(() => [_createVNode(_component_icon, {
            class: "el-icon-question",
            style: {
              "color": "#519eff"
            }
          })]),
          default: _withCtx(() => [_createElementVNode("div", null, "支持类型：" + _toDisplayString(p.srcTyp ? _ctx.srcType[p.srcTyp].typ : '不限'), 1), _createElementVNode("div", null, "格式限制：" + _toDisplayString(p.srcTypSuffix ? p.srcTypSuffix : '不限'), 1), _createElementVNode("div", null, "规格说明：" + _toDisplayString(p.picSize ? p.picSize : '不限'), 1), _createElementVNode("div", null, "文件大小：" + _toDisplayString(p.picFileSize ? '小于' + p.picFileSize + 'kB' : '不限'), 1)]),
          _: 2
        }, 1024)])]), p.srcs.length > 0 ? _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          key: 0,
          data: p.srcs,
          onSelectionChange: val => $setup.handleSelectionChange(val, index)
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            type: "selection",
            "min-width": "1%",
            selectable: $setup.selectable
          }, null, 8, ["selectable"]), _createVNode(_component_el_table_column, {
            prop: "srcName",
            label: "素材名称",
            "min-width": "20%"
          }), _createVNode(_component_el_table_column, {
            prop: "srcTyp",
            label: "素材类型",
            "min-width": "10%"
          }, {
            default: _withCtx(scope => [_createTextVNode(_toDisplayString($setup.getSrcType(scope.row.srcTyp)) + "/" + _toDisplayString(scope.row.extension), 1)]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "state",
            label: "审核状态",
            "min-width": "20%"
          }, {
            default: _withCtx(scope => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.approveInfos, (apprInfo, index) => {
              return _openBlock(), _createElementBlock("div", {
                class: "audit-div-group",
                key: index
              }, [_createElementVNode("div", _hoisted_12, _toDisplayString(apprInfo.roleName), 1), _createVNode(_component_audit_state, {
                state: apprInfo.approveState
              }, null, 8, ["state"])]);
            }), 128))]),
            _: 2
          }, 1024), _createVNode(_component_el_table_column, {
            prop: "state",
            label: "入库状态",
            "min-width": "10%"
          }, {
            default: _withCtx(scope => [_createTextVNode(_toDisplayString($setup.getSrcState(scope.row.state)), 1)]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "操作",
            "min-width": "20%"
          }, {
            default: _withCtx(scope => [scope.row.state == '1' && $setup.isAdmin(p) ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              link: "",
              size: "small",
              onClick: $event => $setup.handleInput(scope.row, p)
            }, {
              default: _withCtx(() => [...(_cache[13] || (_cache[13] = [_createTextVNode("确认入库 ", -1)]))]),
              _: 1
            }, 8, ["onClick"])) : _createCommentVNode("", true), _createVNode(_component_el_button, {
              link: "",
              size: "small",
              onClick: $event => $setup.showPreviewDialog(scope.row)
            }, {
              default: _withCtx(() => [...(_cache[14] || (_cache[14] = [_createTextVNode("预览 ", -1)]))]),
              _: 1
            }, 8, ["onClick"]), scope.row.state != '2' ? (_openBlock(), _createBlock(_component_el_button, {
              key: 1,
              link: "",
              size: "small",
              onClick: $event => $setup.handleDownload(scope.row)
            }, {
              default: _withCtx(() => [...(_cache[15] || (_cache[15] = [_createTextVNode("下载 ", -1)]))]),
              _: 1
            }, 8, ["onClick"])) : _createCommentVNode("", true), scope.row.state != '2' ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              key: 2,
              link: "",
              size: "small",
              onClick: $event => $setup.handleDelete(scope.row.srcId)
            }, {
              default: _withCtx(() => [...(_cache[16] || (_cache[16] = [_createTextVNode("删除 ", -1)]))]),
              _: 1
            }, 8, ["onClick"])), [[_directive_has, 'needs:srcdel']]) : _createCommentVNode("", true), scope.row.state == 0 ? (_openBlock(true), _createElementBlock(_Fragment, {
              key: 3
            }, _renderList($setup.srcAuditRoles, role => {
              return _openBlock(), _createElementBlock(_Fragment, {
                key: role.roleId
              }, ['yewu' === role.roleId ? (_openBlock(), _createElementBlock(_Fragment, {
                key: 0
              }, [_ctx.demand.createrId === _ctx.userInfo.userId ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                link: "",
                size: "small",
                onClick: $event => $setup.showAuditDialog(role, scope.row)
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(role.roleName) + "审核 ", 1)]),
                _: 2
              }, 1032, ["onClick"])) : _createCommentVNode("", true)], 64)) : _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                key: 1,
                link: "",
                size: "small",
                onClick: $event => $setup.showAuditDialog(role, scope.row)
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(role.roleName) + "审核 ", 1)]),
                _: 2
              }, 1032, ["onClick"])), [[_directive_has, role.auth]])], 64);
            }), 128)) : _createCommentVNode("", true), _createVNode(_component_sensitive_words_dialog, {
              "assets-ids": [scope.row.srcId]
            }, null, 8, ["assets-ids"])]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1032, ["data", "onSelectionChange"])), [[_directive_loading, _ctx.loading]]) : _createCommentVNode("", true)]),
        _: 2
      }, 1024);
    }), 128))]),
    _: 1
  })])], 512), [[_vShow, _ctx.$route.path === '/my-needs/finishedDetail']]), _createVNode(_component_detail_aside, {
    ref: "asideRef",
    demandId: _ctx.demandId
  }, null, 8, ["demandId"]), _createVNode(_component_src_audit, {
    visible: _ctx.auditDialogShow,
    "onUpdate:visible": _cache[2] || (_cache[2] = $event => _ctx.auditDialogShow = $event),
    auditRole: _ctx.auditRole,
    multiSrss: _ctx.auditSrss,
    onSave: $setup.loadSrcs,
    onSuccess: $setup.toBack
  }, null, 8, ["visible", "auditRole", "multiSrss", "onSave", "onSuccess"]), _createVNode(_component_el_dialog, {
    title: "预览",
    modelValue: _ctx.previewShow,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _ctx.previewShow = $event),
    width: "540px",
    top: "2%"
  }, {
    default: _withCtx(() => [_createElementVNode("img", {
      src: _ctx.imgUrl,
      width: "500"
    }, null, 8, _hoisted_13)]),
    _: 1
  }, 8, ["modelValue"]), _createVNode(_component_router_view)], 64);
}